// extracted by mini-css-extract-plugin
export default {"languageBtns":"LanguageBtn_languageBtns__0EeI2","active":"LanguageBtn_active__3WsAY"};